import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles/theme.css";
import "./styles/cosmic.css";

// Validate critical environment variables
const requiredEnvVars = [
	'REACT_APP_API_BASE',
	'REACT_APP_AWS_REGION',
	'REACT_APP_USER_POOL_ID',
	'REACT_APP_USER_POOL_CLIENT_ID'
];

const missingVars = requiredEnvVars.filter(varName => !process.env[varName]);

if (missingVars.length > 0) {
	// console.error('❌ Missing required environment variables:', missingVars.join(', '));
	// console.error('Please check your .env.local file and ensure all required variables are set.');
	// Still render but with warning - app will fail at runtime
}

createRoot(document.getElementById("root")).render(
	<React.StrictMode>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</React.StrictMode>
);
